import type { ChatThread } from '~/App/ChatThreads/@types'
import { Message } from '~/DesignSystem/components/messages'

import { IncomingMessage } from '../../../components/messages/IncomingMessage'
import MessageText from '../../../components/messages/MessageText'
import { OutgoingMessage } from '../../../components/messages/OutgoingMessage'
import ImageEvent from './ImageEvent'
import InteractiveEvent from './InteractiveEvent'
import ShareProductsEvent from './ShareProductsEvent'

type MessageProps = React.ComponentProps<typeof Message>

type IncomingMessageProps = {
  items?: ChatThread[]
} & Omit<MessageProps, 'direction' | 'variant'> & {
    direction?: MessageProps['direction']
    variant?: MessageProps['variant']
  }
function Threads({ items }: IncomingMessageProps) {
  return items?.map(item =>
    item.attributes.events.data.map(event => {
      const { attributes } = event
      const text = attributes.text_in_chatter_language || attributes.text
      const time = attributes.timestamp * 1000
      const owner = attributes.author?.data?.attributes.display_name || undefined

      if (attributes.author?.data?.attributes.type === 'CUSTOMER') {
        return (
          <OutgoingMessage time={attributes.timestamp * 1000} key={event.id}>
            <MessageText>{attributes.text_in_chatter_language || attributes.text}</MessageText>
          </OutgoingMessage>
        )
      }

      if (attributes.sub_type === 'text') {
        return (
          <IncomingMessage owner={owner} time={time} key={event.id}>
            <MessageText>{text}</MessageText>
          </IncomingMessage>
        )
      }

      if (attributes.sub_type === 'interactive') {
        return <InteractiveEvent key={event.id} data={event} />
      }

      if (attributes.sub_type === 'image') {
        return <ImageEvent key={event.id} data={event} />
      }

      if (
        attributes.sub_type === 'share_product' ||
        attributes.sub_type === 'share_product_variants'
      ) {
        return <ShareProductsEvent key={event.id} data={event} />
      }

      return undefined
    }),
  )
}

export { Threads }
